/* eslint-disable react/display-name */
import { ControlProps } from '@jsonforms/core'
import { useContext } from 'react'
import { JsonFormCustomContext } from '../QuestionnareForm'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const withHandleChangeEmitter = (Component: any) => {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return (props: ControlProps) => {
    // consume your context which you set up outside of JSON Forms
    const myContextInstance = useContext(JsonFormCustomContext)
    const myEmitter = myContextInstance?.omitEmptyDataHandler

    // create a new handleChange method which first does the regular update and then tells the emitter which data changed
    const handleChangeAndEmit = (path: string, updater: string) => {
      props.handleChange(path, updater)
      if (myEmitter) {
        if (!updater || (updater && updater.trim().length === 0)) {
          myEmitter(path)
        }
      }
    }

    // pass down all props as they are but overwrite handleChange
    return <Component {...props} handleChange={handleChangeAndEmit} />
  }
}
